import { PostAPI, PostAPIWithoutRequest } from "../helper/apiHelper";

export const InsertPropertyOwnerDetails = async (request: any) => {
  return PostAPI(request, 'PropertyOwnerMaster/Insert');
};

export const SelectOwner = async (request: any) => {
  return PostAPI(request,'PropertyOwnerMaster/SelectByUserID');
};

export const InsertPropertyDetails = async (request: any) => {
  return PostAPI(request, 'CommercialPropertyDetails/Insert');
};

export const SelectPropertyDetails = async (request: any) => {
  return PostAPI(request, 'CommercialPropertyDetails/SelectByUserID');
};

export const InsertFinancialDetails = async (request: any) => {
  return PostAPI(request, 'CommercialPropertyFinancialDetails/Insert');
};

export const SelectFinancialDetails = async (request: any) => {
  return PostAPI(request, 'CommercialPropertyFinancialDetails/SelectByUserID');
};

export const InsertMultipleFiles = async (request: any) => {
  return PostAPI(request, 'CommercialPropertyPhotoVideo/InsertMultipleFiles');
};

export const deleteFile = async (request: any) => {
  return PostAPI(request,'CommercialPropertyPhotoVideo/Delete');
};

export const SelectMultipleFiles = async (request: any) => {
  return PostAPI(request,'CommercialPropertyPhotoVideo/SelectFilesByUserID');
};

export const InsertInfraFacilities = async (request: any) => {
  return PostAPI(request,'InfraAndFacilities/Insert');
};

export const SelectInfraFacilities = async (request: any) => {
  return PostAPI(request,'InfraAndFacilities/SelectByUserID');
};

export const SearchProperty = async (request: any) => {
  return PostAPI(request,'CommercialPropertyDetails/SearchProperties');
};